module.exports = __webpack_public_path__ + "img/edit-user.8e6cf563.png";